import React, { useEffect, useState } from "react";
import "./Gallery.css";

const GalleryCard = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const esc = (e) => e.key === "Escape" && setActiveIndex(null);
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, []);

  return (
    <>
      {/* Gallery Grid */}
      <div className="landing-pages">
        <div className="gallery-grid">
          {images.map((item, i) => (
            <div
              className="gallery-item"
              key={i}
              onClick={() => setActiveIndex(i)}
            >
              {item.type === "image" ? (
                <img src={item.src} alt={`gallery-${i}`} />
              ) : (
                <div className="video-thumb">
                  <video src={item.src} muted />
                  <span className="play-icon">▶</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {activeIndex !== null && (
        <div className="lightbox" onClick={() => setActiveIndex(null)}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="lightbox-close"
              onClick={() => setActiveIndex(null)}
            >
              ✕
            </button>

            <button className="lightbox-prev" onClick={prevImage}>
              ‹
            </button>

            {/* 👇 Dynamic rendering */}

            {images[activeIndex].type === "image" ? (
              <img src={images[activeIndex].src} alt="full-view" />
            ) : (
              <video
                src={images[activeIndex].src}
                controls
                autoPlay
                style={{ maxHeight: "80vh" }}
              />
            )}

            <button className="lightbox-next" onClick={nextImage}>
              ›
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryCard;
